import React, { useState  , useEffect } from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

function Project({ project , nameproject , library , statusres , linkdemo , linkgit , image1 , image2 , image3 , image4}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // if (isOpen) {
      //   setIsOpen(false); 
      // }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen]);

  return (
    <div>
      <div id='portfolio' className='flex justify-center'>
        <div className='hover:bg-[#4E4E4E] duration-500 w-11/12 h-20 flex justify-between items-center px-10 border border-b-2 border-zinc-900 cursor-pointer' onClick={() => setIsOpen(!isOpen)}>
          <h2 className='font-primary font-bold text-3xl text-[#D5FF3C]'>{project}</h2>
          <ArrowDownwardIcon sx={{ fontSize: 70, transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }} className='text-[#D5FF3C]' />
        </div>
      </div>
      <div className={`w-11/12 mx-auto transition-all duration-700 ease-in-out overflow-hidden ${isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className='w-full flex flex-wrap items-center bg-[#4E4E4E]'>
          <div className='w-full lg:w-1/2 p-3 lg:p-10 text-sm md:text-xl *:mb-12 font-bold uppercase text-[#D5FF3C]'>
            <h2>NAME PROJECT : {nameproject} </h2>
            <h2>Framework and library : {library} </h2>
            <h2>status : {statusres} </h2>
            <div className='flex justify-center mt-20 gap-5'>
                <a className='hover:bg-[#302f2f] border-2 border-lime-200 text-center rounded-full p-3 w-48' href={linkdemo} target='_blank'>Demo Project</a>
                <a className='hover:bg-[#302f2f] border-2 border-lime-200 text-center rounded-full p-3 w-48' href={linkgit} target='_blank'>LINK GITHUB</a>
            </div>
          </div>
          <div className='w-full lg:w-1/2 p-1 lg:p-5 flex'>
          <div className="container mx-auto p-10">
      <Swiper
        spaceBetween={30}
        loop={true}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
       <SwiperSlide><img src={image1} class="w-3/4 mx-auto h-96"/></SwiperSlide>        
       <SwiperSlide><img src={image2} class="w-3/4 mx-auto h-96"/></SwiperSlide>        
       <SwiperSlide><img src={image3} class="w-3/4 mx-auto h-96"/></SwiperSlide>        
       <SwiperSlide><img src={image4} class="w-3/4 mx-auto h-96"/></SwiperSlide>        
      </Swiper>
    </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;